import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20cinematic%20abstract%20composition%20with%20warm%20coral%20and%20amber%20gradients%2C%20flowing%20organic%20shapes%20resembling%20film%20strips%20and%20motion%20blur%2C%20artistic%20minimal%20style%20with%20soft%20textures%2C%20dark%20and%20warm%20atmosphere%20with%20dramatic%20lighting%2C%20luxurious%20and%20modern%20visual%20design%20inspired%20by%20Chinese%20aesthetics&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="国产视频精选平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-background-50/90 font-medium">
              2026年度 · 国产原创内容精选
            </span>
          </div>

          <h1 className="font-heading font-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 leading-tight mb-4 md:mb-6">
            发现优质
            <span className="text-accent-400">国内原创</span>
            <br />
            视频内容
          </h1>

          <p className="text-sm md:text-base text-background-200/90 max-w-2xl mx-auto leading-relaxed mb-8 md:mb-10">
            国产视频精选平台汇聚海量优质国内原创影视、短视频与纪录片内容，涵盖剧情、喜剧、科技、文化等多元类型，带你感受中国影视创作的蓬勃活力与创意魅力。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-play-circle-line mr-2"></i>
              立即探索
            </Link>
            <Link
              to="/category/documentary"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap hover:bg-background-50/25 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-award-line mr-2"></i>
              精选纪录片
            </Link>
          </div>

          <div className="mt-12 md:mt-16 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl mx-auto">
            {[
              { value: '50,000+', label: '优质视频资源' },
              { value: '3,200+', label: '原创作者入驻' },
              { value: '800万+', label: '月活跃用户' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-1">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-background-300/80">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-background-50/60">
          <i className="ri-arrow-down-s-line text-xl"></i>
        </div>
      </div>
    </section>
  );
}